import { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "./periscope-works-logo.svg";

function Header() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.slice(1);
    const frame = requestAnimationFrame(() => {
      document.getElementById(id)?.scrollIntoView();
    });
    return () => cancelAnimationFrame(frame);
  }, [hash]);

  return (
    <header className="site-header">
      <div className="shell header-bar">
        <NavLink to="/" className="logo-link" aria-label="Periscope Works, home" end>
          <img className="logo" src={logo} alt="" />
        </NavLink>
        <nav className="site-nav" aria-label="Primary">
          <Link to="/#expertise">Expertise</Link>
          <NavLink to="/faqs">FAQ</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>
      </div>
    </header>
  );
}

export default Header;
